import Loader from 'components/shared/Loader'
import { useMemo } from 'react'
import VoucherCode from 'routes/OrderAndPayment/sections/PlaceOrderSection/components/VoucherCode'
import { VoucherPaymentContainer } from 'routes/OrderAndPayment/sections/PlaceOrderSection/components/VoucherPaymentContainer'
import { useCart } from 'store/cart-slice/hooks'
import { useAppSelector } from 'store/hooks'
import { useApp } from 'store/steps'

interface VouchersContentProps {
    deliveryPrice?: number
}

export const useVouchersContent = ({ deliveryPrice }: VouchersContentProps) => {
    const { cart } = useAppSelector((state) => state.cart)
    const { giftCards: selfcareGiftCards } = useAppSelector(
        (state) => state.selfcareCart
    )
    const { appMode } = useApp()
    const { totalPrice, giftCards, beforeDiscountPrice } = cart || {}
    const { isCartFetching, isSummaryFetching } = useCart()

    const voucherContent = useMemo(() => {
        if (appMode === 'selfcare') {
            if (selfcareGiftCards && selfcareGiftCards.length) {
                return {
                    vouchers:
                        isCartFetching || isSummaryFetching ? (
                            <Loader />
                        ) : (
                            selfcareGiftCards.map((giftCard) => (
                                <VoucherCode
                                    key={giftCard.number}
                                    voucher={{ ...giftCard }}
                                />
                            ))
                        ),
                    summary: selfcareGiftCards.map((giftCard) => (
                        <VoucherPaymentContainer
                            key={giftCard.number}
                            totalPrice={totalPrice}
                            voucherValue={giftCard.value}
                            beforeDiscountPrice={beforeDiscountPrice}
                            deliveryPrice={deliveryPrice}
                        />
                    )),
                    voucherDiscount: selfcareGiftCards.reduce(
                        (acc, giftCard) => acc + (giftCard?.value ?? 0),
                        0
                    ),
                }
            }
            return {
                vouchers: <VoucherCode />,
                summary: (
                    <VoucherPaymentContainer
                        totalPrice={totalPrice}
                        beforeDiscountPrice={beforeDiscountPrice}
                        deliveryPrice={deliveryPrice}
                    />
                ),
            }
        }

        if (giftCards && giftCards.length) {
            return {
                vouchers: giftCards.map((giftCard) => (
                    <VoucherCode
                        key={giftCard.number}
                        voucher={{ ...giftCard }}
                    />
                )),
                summary: giftCards.map((giftCard) => (
                    <VoucherPaymentContainer
                        key={giftCard.number}
                        totalPrice={totalPrice}
                        voucherValue={giftCard.value}
                        beforeDiscountPrice={beforeDiscountPrice}
                        deliveryPrice={deliveryPrice}
                    />
                )),
                voucherDiscount: giftCards.reduce(
                    (acc, giftCard) => acc + (giftCard?.value ?? 0),
                    0
                ),
            }
        }
        return {
            vouchers: <VoucherCode />,
            summary: (
                <VoucherPaymentContainer
                    totalPrice={totalPrice}
                    beforeDiscountPrice={beforeDiscountPrice}
                    deliveryPrice={deliveryPrice}
                />
            ),
        }
    }, [
        giftCards,
        totalPrice,
        beforeDiscountPrice,
        deliveryPrice,
        isCartFetching,
        isSummaryFetching,
    ])

    return voucherContent
}
